import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type {
  BackendUpdateErrorResponse,
  DatastoreCollection,
} from '@freelancer/datastore';
import { Datastore } from '@freelancer/datastore';
import type {
  Contest,
  Project,
  ProjectBookmarksCollection,
} from '@freelancer/datastore/collections';
import {
  ProjectBookmark,
  ProjectBookmarkType,
} from '@freelancer/datastore/collections';
import { IconColor } from '@freelancer/ui/icon';
import type { Observable } from 'rxjs';

@Component({
  selector: 'app-project-bookmark-button',
  template: `
    <fl-icon
      *ngIf="!bookmark.subscribed; else removeBookmark"
      flTrackingLabel="projectBookmarkButton"
      i18n-label="Bookmark label"
      label="Bookmark"
      [clickable]="true"
      [color]="color"
      [name]="'ui-bookmark-v2'"
      (click)="handleClick($event)"
    ></fl-icon>
    <ng-template #removeBookmark>
      <fl-icon
        flTrackingLabel="projectBookmarkButton"
        i18n-label="Remove bookmark label"
        label="Remove Bookmark"
        [clickable]="true"
        [color]="colorSubscribed"
        [name]="'ui-bookmark-solid-v2'"
        (click)="handleClick($event)"
      ></fl-icon>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectBookmarkButtonComponent {
  bookmark$: Observable<ProjectBookmark>;
  bookmarksCollection: DatastoreCollection<ProjectBookmarksCollection>;

  @Input() color = IconColor.FOREGROUND;
  @Input() colorSubscribed = IconColor.SECONDARY;
  @Input() project: Project | Contest;
  @Input() type: ProjectBookmarkType;
  @Input() bookmark: ProjectBookmark;

  @Output() error = new EventEmitter<
    BackendUpdateErrorResponse<ProjectBookmarksCollection>
  >();
  @Output() success = new EventEmitter<void>();

  constructor(private datastore: Datastore) {}

  handleClick(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    this.datastore
      .document<ProjectBookmarksCollection>(
        'projectBookmarks',
        this.bookmark.id,
      )
      .update({ subscribed: !this.bookmark.subscribed })
      .then(response => {
        if (response.status === 'success') {
          if (!this.bookmark.subscribed) {
            this.success.emit();
          }
        } else {
          this.error.emit(response);
        }
      });
  }
}
